/**
 * Created by eritru on 2016-06-06.
 */

var map_avant = null;
var map_apres = null;
var ue_entier_cb = false;

function operationUeChargementCarte(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, idProcessus, isModeReadOnly, creationMatricule,deplacementBail ) {
    wait.start();
    //17875
    idMap = getInfoMap(idMunicipalite, 31);

    bbox = {
        'derniereDateFermetureCycle': '2010-11-10',
        'derniereDateFermetureGeomatique': '2010-11-10',
        'xmax': '-75.2583983263144',
        'xmin': '-72.3930260161919',
        'ymax': '44.9688409017251',
        'ymin': '50.8478823529871'
    };

    // #15697
    if (creationMatricule == 'True' || deplacementBail == 'True') {

        cadastreAddMapApres();

        var baseMaps = getBaseMap('carte_1');

        map_apres = new L.Map('map-apres', {center: new L.LatLng(46.0, -72.4), zoom: 6, maxZoom: 23});
        map_apres.removeControl(map_apres.attributionControl);
        map_apres.addLayer(googleStreetsApres);
        map_apres.removeControl(map_apres.attributionControl);

        getBboxMunicipalite(idMunicipalite, function (bbox) {
            cadastreInitMapCreationMatricule(idMunicipalite, bbox, 'map-apres', idMap, dateEvenement, idTypeEvenement, idProcessus, isModeReadOnly);
        });

    } else {
        var listAvant = creationListAvantApres(idEvenement, dateEvenement, 'avant', idTypeEvenement);

        var dateEvenementAvant;
        var listMatriculeAvant = [];
        var listLotAvant = [];
        $.each(listAvant, function (index, id_ue) {
            listMatriculeAvant.push(id_ue.matricule);
            dateEvenementAvant = id_ue.date_evenement;

            $.each(id_ue.lot, function (index, lot) {
                listLotAvant.push(lot);
            });
        });

        //Initialisation de la map après dans le callback de l'initialisation de la première map, pour éviter des conflits
        var dateEvenementApres;
        var listApres = creationListAvantApres(idEvenement, dateEvenement, 'apres', idTypeEvenement);
        var listMatriculeApres = [];
        $.each(listApres, function (index, id_ue) {
            listMatriculeApres.push(id_ue.matricule);
            dateEvenementApres = id_ue.date_evenement;
        });

        cadastreAddMapAvant();
        cadastreAddMapApres();

        getBboxMunicipalite(idMunicipalite, function (bbox) {
            //initialisation de la map avant
            cadastreInitMapAvant(idMunicipalite, bbox, 'map-avant', idMap, idEvenement, dateEvenement, dateEvenementAvant, listMatriculeAvant, idTypeEvenement, listLotAvant, idProcessus, isModeReadOnly);
        });

        if (map_avant) {
            map_avant.setView(new L.LatLng(46.0, -72.4), 6);
            map_avant.options.maxZoom = 23;
        }
        else {
             map_avant = new L.Map('map-avant', {center: new L.LatLng(46.0, -72.4), zoom: 6, maxZoom: 23});
        }
        map_avant.addLayer(googleStreets);
        map_avant.removeControl(map_avant.attributionControl);

        map_apres = new L.Map('map-apres', {center: new L.LatLng(46.0, -72.4), zoom: 6, maxZoom: 23});
        map_apres.addLayer(googleStreetsApres);
        map_apres.removeControl(map_apres.attributionControl);

    }

    wait.stop();
}

function creationListAvantApres(idEvenement, dateEvenement, myDate, idTypeEvenement) {

    var listAvantApres = '';
    var params = {
        'idEvenement': idEvenement,
        'dateEvenement': dateEvenement,
        'myDate': myDate,
        'idTypeEvenement': idTypeEvenement
    };

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/operation-ue/get-list-avant-apres/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            listAvantApres = response;
        }
    });
    return listAvantApres;
}

function cadastreInitMapAvant(idMunicipalite, bbox, div_map, idMap, idEvenement, dateEvenement, dateEvenementAvant, listMatriculeAvant, idTypeEvenement, listLotAvant, idProcessus, isModeReadOnly) {



    try {
        map_avant.remove();
        map_avant.removeLayer(googleStreets);
    } // Ceci plante dans i.e. alors...
    catch (err) {
    }


    map_avant = new L.Map(div_map, {});

    osm = new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 23
    });

    var baseMaps = getBaseMap('carte_1');

    map_avant.addLayer(googleStreets);

    var overlays = [{}];

    var options = {
        container_width: "250px",
        group_maxHeight: "200px",
        container_maxHeight: "600px"
    };


    var control = L.Control.styledLayerControl(baseMaps, overlays, options);
    // 9243, Le contrôle de map dans le aprés ne fonctionne pas bien (conflit)
    // map_avant.addControl(control);


    //ON OBTIENT L'URL DE GEOSERVER DEPUIS LE SETTINGS
    var urlGeoserver = $('#urlGeoserver').val();
    //ON CONFIGURE AUTOMATIQUEMENT LES LAYERS DE LA MAP DEPUIS LA BD À L'AIDE DE NOTRE PLUGIN LEAFLET

    map_avant = map_avant.buildEvbMap({
        idMap: idMap,
        zoomToMapExtent: false,
        controlLayers: control,
        urlGeoserver: urlGeoserver,
        urlOrthosGeoserver: $('#urlOrthosGeoserver').val(),
        idMunicipalite: idMunicipalite,
        bbox: bbox,
        dateEvenement: dateEvenementAvant,
        isBrowserCacheEnabled: false,
        callback: function () {
            map_avant.LotFeatureByAttribute(listMatriculeAvant, true, false, 'matricule', false, idEvenement, idTypeEvenement); // polygon de lot composant l'unité d'évaluation
            map_avant.markerFeatureByAttribute(listMatriculeAvant, false, false, 'proprio_proche', false, dateEvenementAvant, '', idTypeEvenement, idProcessus, idEvenement); //marker de proprio
            map_avant.markerFeatureByAttribute(listMatriculeAvant, false, false, 'acheteur', false, dateEvenementAvant, '', idTypeEvenement, idProcessus, idEvenement); //marker du cessionnaire

            refreshTableAvantOperationCadastrale();

            //Initialisation de la map après dans le callback de l'initialisation de la première map, pour éviter des conflits
            var dateEvenementApres;
            var listApres = creationListAvantApres(idEvenement, dateEvenement, 'apres', idTypeEvenement);
            var listMatriculeApres = [];
            $.each(listApres, function (index, id_ue) {
                listMatriculeApres.push(id_ue.matricule);
                dateEvenementApres = id_ue.date_evenement;
            });
            // la fonction callback ne semble fonctionné correctement, l'application d'un timeout règle le problème

            setTimeout(function () {
                cadastreInitMapApres(idMunicipalite, bbox, 'map-apres', idMap, dateEvenementApres, idEvenement, listMatriculeAvant, listMatriculeApres, dateEvenementAvant, dateEvenementApres, idTypeEvenement, listLotAvant, idProcessus, isModeReadOnly);
            }, 100);
        }
    });

    map_avant.whenReady(function() {
        init_layer_group_checkbox_and_layer_menu_styles();
    });

    function activerSelectFeatureAvant() {
        map_avant.EnableLotFeatureByAttribute({
            url: '/gestion-roles/tenue-a-jour/operation-ue/lot.json/',
            zoomToFeature: true,
            idMunicipalite: idMunicipalite,
            dateEvenement: dateEvenementAvant,
            callbackBeforeSelect: function () {

            },
            callback: function (properties) {

                if (properties != null) {
                    map_avant.fitBounds(map_avant._lotLayer.getBounds(), {padding: [100, 100]});
                }

            }
        });

        map_avant.EnableSelectFeatureByAttribute({
            url: '/gestion-roles/tenue-a-jour/operation-ue/unite-evaluation.json/',
            zoomToFeature: true,
            idMunicipalite: idMunicipalite,
            dateEvenement: dateEvenementAvant,
            callbackBeforeSelect: function () {
            },
            callback: function (properties) {
            }
        });

        map_avant.EnableMarkerFeatureByAttribute({
            url: '/gestion-roles/tenue-a-jour/operation-ue/marker.json/',
            zoomToFeature: true,
            idMunicipalite: idMunicipalite,
            dateEvenement: dateEvenementAvant,

            callbackBeforeSelect: function () {

            },
            callback: function (properties) {

            }
        });

        if (!isModeReadOnly) {

            // Active la sélection sur la carte des unités d'évaluation
            map_avant.EnableSelectFeatureOnMap({
                url: '/gestion-roles/tenue-a-jour/operation-ue/unite-evaluation.json/',
                zoomToFeature: true,
                idMunicipalite: idMunicipalite,
                dateEvenement: dateEvenementAvant,
                callback: function (properties) {
                },
                callbackBeforeSelect: function () {
                }
            });
        }
    }

    activerSelectFeatureAvant();
}

function cadastreInitMapApres(idMunicipalite, bbox, div_map, idMap, dateEvenement, idEvenement, listMatriculeAvant, listMatriculeApres, dateEvenementAvant, dateEvenementApres, idTypeEvenement, listLotAvant, idProcessus, isModeReadOnly) {
    // Cas d'une annulation
    if (listMatriculeApres.length != 0) {
        try {
            map_apres.remove();
            map_apres.removeLayer(googleStreetsApres);
        } // Ceci plante dans i.e. alors...
        catch (err) {
        }

        map_apres = new L.Map(div_map, {});

        //17875
        var baseMaps = getBaseMap('carte_2');

        map_apres.addLayer(googleStreetsApres);

        var overlays = [{}];

        var options = {
            container_width: "250px",
            group_maxHeight: "200px",
            container_maxHeight: "600px"
        };

        var control = L.Control.styledLayerControl(baseMaps, overlays, options);
        map_apres.addControl(control);
        $("#map-controls-apres").append(control.getContainer());

        //ON OBTIENT L'URL DE GEOSERVER DEPUIS LE SETTINGS
        var urlGeoserver = $('#urlGeoserver').val();

        //ON CONFIGURE AUTOMATIQUEMENT LES LAYERS DE LA MAP DEPUIS LA BD À L'AIDE DE NOTRE PLUGIN LEAFLET
        map_apres = map_apres.buildEvbMap({
            idMap: idMap,
            zoomToMapExtent: false,
            controlLayers: control,
            urlGeoserver: urlGeoserver,
            urlOrthosGeoserver: $('#urlOrthosGeoserver').val(),
            idMunicipalite: idMunicipalite,
            bbox: bbox,
            dateEvenement: dateEvenement,
            callback: function () {

                // Ajout de geojson _lotLayer
                map_apres.LotFeatureByAttribute(listMatriculeApres, true, false, 'num_lot', false, idEvenement, idTypeEvenement, listMatriculeAvant); // polygon de lot;
                // Ajout de geojson _MarkerLayer, featureClass mat_mat_cr_t
                map_apres.markerFeatureByAttribute(listMatriculeApres, false, false, 'mat_mat_cr_t', false);
                // Ajout de geojson _MarkerLayer, featureClass batiment
                map_apres.markerFeatureByAttribute(listMatriculeAvant, false, false, 'batiment', false, dateEvenementAvant, dateEvenementApres, idTypeEvenement, idProcessus, idEvenement);
                //
                if (map_avant._lotLayer.getBounds().isValid()) {
                    map_apres.fitBounds(map_avant._lotLayer.getBounds(), {padding: [0, 0]});
                }

                refreshTableApresOperationCadastrale(isModeReadOnly);
                fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
            }
        });

        map_apres.whenReady(function() {
            init_layer_group_checkbox_and_layer_menu_styles();
        });

        function activerSelectFeatureApres() {
            //Permet de selectionner une unité d'évaluation sur la carte

            map_apres.EnableLotFeatureByAttribute({
                url: '/gestion-roles/tenue-a-jour/operation-ue/lot.json/',
                zoomToFeature: true,
                idMunicipalite: idMunicipalite,
                dateEvenement: dateEvenement,

                callbackBeforeSelect: function () {
                },
                callback: function (properties) {

                    if (properties == null) {
                        infos.ajouterMessageToast({
                            message: "Nous ne retrouvons pas les lots sur la matrice graphique. Veuillez svp contacter un administrateur",
                            messageDuree: 5000,
                            messageCouleur: 'red'
                        });
                    }

                }
            });

            map_apres.EnableMarkerFeatureByAttribute({
                url: '/gestion-roles/tenue-a-jour/operation-ue/marker.json/',
                zoomToFeature: true,
                idMunicipalite: idMunicipalite,
                dateEvenement: dateEvenement,
                isModeReadOnly: isModeReadOnly,
                callbackBeforeSelect: function () {

                },
                callback: function (properties) {


                }
            });

            // Active la sélection sur la carte des lots
            if (!isModeReadOnly) {


                map_apres.EnableSelectMultipleFeatureOnMap({
                    url: '/gestion-roles/tenue-a-jour/operation-ue/lot.json/',
                    zoomToFeature: true,
                    idMunicipalite: idMunicipalite,
                    dateEvenement: dateEvenement,
                    idEvenement: idEvenement,
                    idTypeEvenement: idTypeEvenement,
                    listMatriculeAvant: listMatriculeAvant,

                    ueEntierCb: ue_entier_cb,
                    callback: function (properties) {
                        if (!$.isEmptyObject(properties)) {
                            if (properties.matricule === undefined) {
                                infos.ajouterMessageToast({message: "Attention veuillez sélectionner un lot"});
                            }
                        }
                    }
                });
            }
        }

        activerSelectFeatureApres();

        if (!isModeReadOnly) {
            //-------------------------------------------------------------
            // # 11734
            //outil de dessin et ses parametres
            var drawnItems = L.featureGroup().addTo(map_apres);

            map_apres.addControl(new L.Control.Draw({
                position: 'topright',

                edit: {
                    featureGroup: drawnItems,
                    poly: {
                        allowIntersection: false
                    }
                },
                draw: {
                    marker: false,
                    circlemarker: false,
                    polygon: {
                        allowIntersection: false,
                        showArea: true,
                        showLength: true
                    }
                }
            }));

            map_apres.on(L.Draw.Event.CREATED, function (event) {
                var layer = event.layer;
                drawnItems.addLayer(layer);
            });

            map_apres.on('draw:created', function (event) {
                var layer = event.layer;
                drawnItems.addLayer(layer);
            });

            map_apres.on('draw:drawstart', function (event) {
                map_apres.DisableSelectMultipleFeatureOnMap(false);
                var geojsonLotMultipleLayer = map_apres._geojsonLotMultipleLayer;
                map_apres.removeLayer(geojsonLotMultipleLayer);
                geojsonLotMultipleLayer.clearLayers();
            });

            map_apres.on('draw:editstart', function (event) {
                map_apres.DisableSelectMultipleFeatureOnMap(false);
                var geojsonLotMultipleLayer = map_apres._geojsonLotMultipleLayer;
                map_apres.removeLayer(geojsonLotMultipleLayer);
                geojsonLotMultipleLayer.clearLayers();
            });

            map_apres.on('draw:deletestart', function (event) {
                map_apres.DisableSelectMultipleFeatureOnMap(false);
                var geojsonLotMultipleLayer = map_apres._geojsonLotMultipleLayer;
                map_apres.removeLayer(geojsonLotMultipleLayer);
                geojsonLotMultipleLayer.clearLayers();
            });

            // identification tjs actif

            map_apres.on('draw:drawstop', function (event) {
                map_apres.EnableSelectMultipleFeatureOnMap({
                    url: '/gestion-roles/tenue-a-jour/operation-ue/lot.json/',
                    zoomToFeature: true,
                    idMunicipalite: idMunicipalite,
                    dateEvenement: dateEvenement,
                    idEvenement: idEvenement,
                    idTypeEvenement: idTypeEvenement,
                    listMatriculeAvant: listMatriculeAvant,
                    ueEntierCb: ue_entier_cb,
                    callback: function (properties) {
                        if (!$.isEmptyObject(properties)) {
                            if (properties.matricule === undefined) {
                                infos.ajouterMessageToast({message: "Attention veuillez sélectionner un lot"});
                            }
                        }
                    }
                });
            });

            map_apres.on('draw:editstop', function (event) {
                map_apres.EnableSelectMultipleFeatureOnMap({
                    url: '/gestion-roles/tenue-a-jour/operation-ue/lot.json/',
                    zoomToFeature: true,
                    idMunicipalite: idMunicipalite,
                    dateEvenement: dateEvenement,
                    idEvenement: idEvenement,
                    idTypeEvenement: idTypeEvenement,
                    listMatriculeAvant: listMatriculeAvant,
                    ueEntierCb: ue_entier_cb,
                    callback: function (properties) {
                        if (!$.isEmptyObject(properties)) {
                            if (properties.matricule === undefined) {
                                infos.ajouterMessageToast({message: "Attention veuillez sélectionner un lot"});
                            }
                        }
                    }
                });
            });

            map_apres.on('draw:deletestop', function (event) {
                map_apres.EnableSelectMultipleFeatureOnMap({
                    url: '/gestion-roles/tenue-a-jour/operation-ue/lot.json/',
                    zoomToFeature: true,
                    idMunicipalite: idMunicipalite,
                    dateEvenement: dateEvenement,
                    idEvenement: idEvenement,
                    idTypeEvenement: idTypeEvenement,
                    listMatriculeAvant: listMatriculeAvant,
                    ueEntierCb: ue_entier_cb,
                    callback: function (properties) {
                        if (!$.isEmptyObject(properties)) {
                            if (properties.matricule === undefined) {
                                infos.ajouterMessageToast({message: "Attention veuillez sélectionner un lot"});
                            }
                        }
                    }
                });
            });

            //-------------------------------------------------------------

            L.easyButton('fa-eraser', function () {

                var geojsonLayer = map_avant._geojsonLayer;
                map_avant.removeLayer(geojsonLayer);
                geojsonLayer.clearLayers();
                map_avant._initLotGeojsonLayer();

            }, 'Annulation de la sélection').addTo(map_avant);


            L.easyButton('fa-plus-square', function () {
                ueCreation();
                activerSauvegarde();

            }, 'Créer une nouvelle UE').addTo(map_apres);


            L.easyButton('fa-eraser', function () {

                var geojsonLotMultipleLayer = map_apres._geojsonLotMultipleLayer;
                map_apres.removeLayer(geojsonLotMultipleLayer);
                geojsonLotMultipleLayer.clearLayers();
                map_apres._initGeojsonLayerMultiple();

            }, 'Annulation de la sélection').addTo(map_apres);

            // create the control
            var command = L.control({position: 'topleft'});

            command.onAdd = function () {
                var div = L.DomUtil.create('div', 'ue_entier');
                div.innerHTML = '<form class="sig-custom-form"><input id="ue_entier" type="checkbox"/>Unité d\'évaluation</form>';
                return div;
            };
            command.addTo(map_apres);

            $('#ue_entier').on('click', function () {
                ue_entier_cb = this.checked;
            });
            $("#ue_entier").mouseover(function () {
                map_apres.DisableSelectMultipleFeatureOnMap(false);
            });

            $("#ue_entier").mouseout(function () {
                map_apres.EnableSelectMultipleFeatureOnMap({
                    url: '/gestion-roles/tenue-a-jour/operation-ue/lot.json/',
                    zoomToFeature: true,
                    idMunicipalite: idMunicipalite,
                    dateEvenement: dateEvenement,
                    idEvenement: idEvenement,
                    idTypeEvenement: idTypeEvenement,
                    listMatriculeAvant: listMatriculeAvant,
                    ueEntierCb: ue_entier_cb,
                    callback: function (properties) {
                        if (!$.isEmptyObject(properties)) {
                            if (properties.matricule === undefined) {
                                infos.ajouterMessageToast({message: "Attention veuillez sélectionner un lot"});
                            }
                        }
                    }
                });
            });


        }
        wait.stop('contenu', false);
    } else {
        $('#carte-apres').remove();
        $("#tableau-apres").remove();
        wait.stop('contenu', false);

    }
}

function refreshTableAvantOperationCadastrale() {
    var lotLayer = map_avant._lotLayer;
    var matricule = '';
    var html = '';
    var listMatricule = [];

    $("#table-avant-operation-cadastrale").find('tbody').html('');

    lotLayer.eachLayer(function (layer) {

        var row = '';
        matricule = layer.feature.properties.matricule;

        //On s'assure de pas passer deux fois le même matricule
        if (jQuery.inArray(matricule, listMatricule) == -1) {

            listMatricule.push(matricule);

            row = '<tr style="background-color:rgba(' + layer.feature.properties.color_rgb + ');">';
            row += '<td id="id-ue">' + layer.feature.properties.id_ue + '</td>';
            // row += '<td id="matricule">' + layer.feature.properties.matricule + '-000-0000' + '</td>';

            row += '<td style="background-color:white" id="matricule"><button class="hyperlien-tableau-operation-ue" onclick="selectUniteEvaluation(\'' + layer.feature.properties.matricule +'\')">' + layer.feature.properties.matricule + '-000-0000' + '</button></td>';



            var listLot = layer.feature.properties.information_ue[0]['liste_no_lot'].split(',');
            var lot = '';
            $.each(listLot, function (k, v) {
                lot += v + '<br>';
            });
            row += '<td>' + lot + '</td>';

            row += '<td>' + layer.feature.properties.information_ue[0]['liste_proprios'] + '</td>';
            //<td title="{{ valeur.liste_proprios|truncatechars:15 }}">{{ valeur.liste_proprios|default_if_none:"" }}</td>
            row += '<td>' + layer.feature.properties.information_ue[0]['valeur_immeuble'] + '</td>';
            row += '<td>' + layer.feature.properties.information_ue[0]['superficie'] + '</td>';
            row += '<td title="' + layer.feature.properties.information_ue[0]['description_code_utilisation'] + '">' + layer.feature.properties.information_ue[0]['code_utilisation'] + '</td>';
            row += '<td>' + layer.feature.properties.information_ue[0]['nb_batiment'] + '</td>';
            row += '<td>' + layer.feature.properties.information_ue[0]['nb_evenement'] + '</td>';

            row += '</tr>';
            html += row;

        }
    });

    $("#table-avant-operation-cadastrale").find('tbody').html(html);
}

function selectUniteEvaluation(matriculeSelectionne){

     map_avant.selectFeatureByAttribute(matriculeSelectionne, true, true);

}

function refreshTableApresOperationCadastrale(isModeReadOnly) {
    isModeReadOnly = isModeReadOnly || false;

    var lotLayer = map_apres._lotLayer;
    var matricule = '';
    var html = '';
    var listMatricule = [];

    $("#table-apres-operation-cadastrale").find('tbody').html('');

    lotLayer.eachLayer(function (layer) {

        var row = '';
        matricule = layer.feature.properties.matricule;

        //On s'assure de pas passer deux fois le même matricule
        if (jQuery.inArray(matricule, listMatricule) == -1) {

            listMatricule.push(matricule);

            row = '<tr style="background-color:rgba(' + layer.feature.properties.color_rgb + ');">';
            row += '<td id="id-ue">' + layer.feature.properties.id_ue + '</td>';
            row += '<td id="id-ue-creation">' + layer.feature.properties.id_ue_creation + '</td>';
            row += '<td id="matricule">' + layer.feature.properties.matricule + '-000-0000' + '</td>';
            // liste les lots par matricule
            row += '<td>' + lotXMatricule(layer.feature.properties.matricule) + '</td>';
            //liste les batiments par matricule
            row += '<td>' + batimentXMatricule(layer.feature.properties.matricule) + '</td>';
            //liste les natures par matriculef
            row += '<td>' + natureXMatricule(layer.feature.properties.matricule) + '</td>';

            var boutonAssocier = '';
            if (!isModeReadOnly) {
                if (layer.feature.properties.id_ue == '') {
                    boutonAssocier = '<a id="btn-existant-operation-cadastrale" href="#modal" title="Associer à une unité d\'évaluation existante"> <i class="ace-icon fa fa-plus-square-o fa-lg test_eric"></i> </a>';

                } else {
                    boutonAssocier = '<a id="btn-inexistant-operation-cadastrale" href="#modal" title="Supprimer l\'unité d\'évaluation existante"> <i class="ace-icon fa fa-minus-square-o fa-lg test_eric"></i> </a>';

                }
            }

            row += '<td align="center">' + boutonAssocier + '</td>';


            row += '</tr>';
            html += row;

        }
    });

    $("#table-apres-operation-cadastrale").find('tbody').html(html);
    wait.stop('contenu', false);
    //initialisation du bouton associés


    $('#table-apres-operation-cadastrale a').off().on('click', function () {
        var listUeSelect = findUeSelectionAvant();
        var matricule = $(this).closest('tr').find('#matricule').html();
        var myBtn = $(this).attr('id');
        var idEvenement = $('#wizard').attr('id-evenement');
        var idTypeEvenement = $('#wizard').attr('id-type-evenement');
        var dateEvenement = $('#wizard').attr('date-evenement');
        var idMunicipalite = $('#wizard').attr('id-municipalite');
        var message = false;

        if (map_apres._lotLayer) {

            //itère sur lotLayer (tous les polygones en couleur dans le après, l'équivalent du tableau
            var messageErreur = '1';
            var listeMatriculeVsMatriculeAvant = [];
            var listeUeNature = []
            for (var i in map_apres._lotLayer._layers) {
                var layer = map_apres._lotLayer._layers[i];
                var listAvant;
                var listIdUeAvant;
                var natures;
                var tmpIdUeCreation;
                var listLot = lotXMatriculeList(layer.feature.properties.matricule);
                // Correspond au matricule du bouton qu'on vient de cliquer dans la colonne Actions du tableau
                if (matricule.search(layer.feature.properties.matricule) !== -1) {
                    tmpIdUeCreation = layer.feature.properties.id_ue_creation;

                    // si c'est le bouton + qu'on a cliqué pour cette ligne (associer une UE existante)
                    if (myBtn === 'btn-existant-operation-cadastrale') {
                        // si une unité d'évaluation de sélectionner dans la carte de gauche
                        if (listUeSelect.length === 1) {
                            // --------------------------------------------------------------
                            // l'UE n'est pas impliqué dans la mutation
                            listAvant = findIdUeTableauAvant();
                            listIdUeAvant = [];
                            $.each(listAvant, function (index, id_ue) {
                                listIdUeAvant.push(id_ue);
                            });
                            if (jQuery.inArray(listUeSelect[0], listIdUeAvant) === -1) {
                                messageErreur = "L'UE " + listUeSelect[0] + " ne peut pas être associée à cette " +
                                    "UE car son matricule dans la carte de droite n'a pas de correspondance dans la " +
                                    "carte de gauche. Veuillez contacter un administrateur afin de poursuivre votre " +
                                    "traitement.";
                                infos.ajouterMessageToast({
                                    message: messageErreur,
                                    messageDuree: 0,
                                    messageCouleur: 'red'
                                });
                                layer.feature.properties.id_ue = '';
                                break;
                            }
                            layer.feature.properties.id_ue = listUeSelect[0];
                            var listLotAvant = findLotTableauAvant(listUeSelect[0]);
                            var listLotApres = [];
                            $.each(listLot, function (index, lot) {
                                listLotApres.push(lot.split('/')[1]);
                            });
                            if (jQuery.inArray(listUeSelect[0], listIdUeAvant) !== -1) {
                                setMatriculeAvantMemeGeom(matricule, listeMatriculeVsMatriculeAvant, layer,
                                    idMunicipalite, listLotAvant, listLotApres, dateEvenement, listUeSelect[0]);
                            }
                            tmpIdUeCreation = '';
                            layer.feature.properties.id_ue_creation_backup = layer.feature.properties.id_ue_creation;
                        } else {
                            message = true;
                            break;
                        }
                    } else {
                        // si c'est le bouton - qu'on a cliqué pour cette ligne (supprimer l'association à une UE existante)
                        layer.feature.properties.id_ue = '';
                        tmpIdUeCreation = layer.feature.properties.id_ue_creation_backup;
                    }
                    setNaturesParLayer(
                        layer, listeUeNature, listLot, idEvenement, idTypeEvenement, dateEvenement, tmpIdUeCreation);

                } else { // si la ligne courante de la boucle n'est PAS celle qu'on a cliqué le bouton dans Actions
                    if (layer.feature.properties.id_ue === listUeSelect[0]) { // si la ligne courante correspond à l'UE sélectionnée dans la carte de gauche
                        tmpIdUeCreation = layer.feature.properties.id_ue_creation;

                        if (myBtn === 'btn-existant-operation-cadastrale') { // si le bouton Actions de la ligne courante est rendu un +
                            layer.feature.properties.id_ue = '';
                            tmpIdUeCreation = layer.feature.properties.id_ue_creation_backup;
                        } else {
                            if (listUeSelect.length === 1) {
                                listAvant = findIdUeTableauAvant();
                                listIdUeAvant = [];
                                $.each(listAvant, function (index, id_ue) {
                                    listIdUeAvant.push(id_ue);
                                });
                                if (jQuery.inArray(listUeSelect[0], listIdUeAvant) === -1) {
                                    infos.ajouterMessageToast({
                                        message: "l'ID_UE : " + listUeSelect[0] + " ne peut pas être associé à cette UE ",
                                        messageDuree: 3000,
                                        messageCouleur: 'red'
                                    });
                                } else {
                                    layer.feature.properties.id_ue = listUeSelect[0];
                                    tmpIdUeCreation = '';
                                    layer.feature.properties.id_ue_creation_backup = layer.feature.properties.id_ue_creation;
                                }
                            } else {
                                message = true;
                                break;
                            }
                        }
                        setNaturesParLayer(
                            layer, listeUeNature, listLot, idEvenement, idTypeEvenement, dateEvenement, tmpIdUeCreation);
                    }
                }
            }

            map_apres._lotLayer.eachLayer(function (layer) {
                if (layer.feature.properties.matricule_avant) {
                    layer.feature.properties.matricule = layer.feature.properties.matricule_avant;
                    delete layer.feature.properties.matricule_avant;
                }
            });
        }
        if (message) {
            infos.ajouterMessageToast({message: "Veuillez sélectionner une unité d'évaluation existante dans la carte de gauche ", messageDuree: 3000, messageCouleur: 'red'}); //1500 = 1,5 secondes
        }
        refreshTableApresOperationCadastrale();
        //Active le bouton sauvegarder
        activerSauvegarde();
    });
}

function setMatriculeAvantMemeGeom(matricule, listeMatriculeVsMatriculeAvant, layer, idMunicipalite, listLotAvant,
                                   listLotApres, dateEvenement, idUe) {
    let elementMatricule = listeMatriculeVsMatriculeAvant.filter(x => matricule in x);
    if (elementMatricule.length) {
        // si on trouve le matricule et qu'il y a un matricule avant(géométrie identique), alors assigner le matricule avant
        if (elementMatricule[0][matricule]) {
            layer.feature.properties.matricule_avant = elementMatricule[0][matricule];
        }
    } else {
        if (validerUeGeomIdentique(idMunicipalite, listLotAvant, listLotApres, dateEvenement)) {
            // si l'ue a une géométrie identique à celle d'avant, alors on peut trouver le matricule d'avant dans le tableau de gauche
            let matriculeAvant = findMatriculeTableauAvant(idUe);
            if (matriculeAvant !== '') {
                layer.feature.properties.matricule_avant = matriculeAvant;
                listeMatriculeVsMatriculeAvant.push({[matricule]: matriculeAvant})
            }
        } else {
            listeMatriculeVsMatriculeAvant.push({[matricule]: ''})
        }
    }
}

function setNaturesParLayer(layer, listeUeNature, listLot, idEvenement, idTypeEvenement, dateEvenement, tmpIdUeCreation) {
    let natures;
    let ueNature = listeUeNature.filter(x => layer.feature.properties.id_ue in x);
    if (!ueNature.length) {
        natures = findNature(layer.feature.properties.id_ue, listLot, idEvenement, idTypeEvenement, dateEvenement);
        listeUeNature.push({[layer.feature.properties.id_ue]: natures});
    }
    else {
        natures = ueNature[0][layer.feature.properties.id_ue];
    }

    if (natures.properties.natures[0] === 'error' || natures.properties.natures[0] === ' ') {
        layer.feature.properties.id_ue = '';
        infos.ajouterMessageToast({
            message: "Ne peut pas être associé à cette UE",
            messageDuree: 3000,
            messageCouleur: 'red'
        });
    } else {
        layer.feature.properties.nature = natures.properties.natures;
        layer.feature.properties.no_nature = natures.properties.no_nature;
        layer.feature.properties.id_ue_creation = tmpIdUeCreation;
    }
}

function findLotTableauAvant(id_ue) {

    var lotLayer = map_avant._lotLayer;
    // On creer un array de matricule
    var listLot = [];
    if (lotLayer) {
        lotLayer.eachLayer(function (layer) {
            if (layer.feature.properties.id_ue == id_ue) {
                if (jQuery.inArray(layer.feature.properties.id_ue, listLot) == -1) {
                    listLot.push(layer.feature.properties.lot.split('/')[1]);
                }
            }
        });
    }
    return listLot;
}

function findIdUeTableauAvant() {

    var lotLayer = map_avant._lotLayer;
    // On creer un array de id_ue
    var listIdUe = [];
    if (lotLayer) {
        lotLayer.eachLayer(function (layer) {
            if (jQuery.inArray(layer.feature.properties.id_ue, listIdUe) === -1) {
                listIdUe.push(layer.feature.properties.id_ue);
            }
            // }
        });
    }
    return listIdUe;
}

function findMatriculeTableauAvant(idUe) {
    var lotLayer = map_avant._lotLayer;
    var matricule = '';
    if (lotLayer) {
        lotLayer.eachLayer(function (layer) {
            if (layer.feature.properties.id_ue === idUe) {
                matricule = layer.feature.properties.matricule;
            }
        });
    }
    return matricule;
}

function findNature(idUe, listLot, idEvenement, idTypeEvenement, dateEvenement) {

    var reponse = '';
    var params = {
        'idUe': idUe,
        'listLot': listLot,
        'idEvenement': idEvenement,
        'idTypeEvenement': idTypeEvenement,
        'dateEvenement': dateEvenement
    };

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/operation-ue/find-nature/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            reponse = response;
        }
    });
    return reponse;
}


function videIdUe(idUe) {

    $("#table-apres-operation-cadastrale").find("td:nth-child(1)").each(function () {
        if ($(this).html() == idUe) {
            $(this).html('');
        }
    });

}

function batimentMove(ev, ueLayerAvant, ueLayerApres, municipalite) {

    var positionDeplace = ev.getLatLng();

    var lng = ev.feature.geometry.coordinates[0];
    var lat = ev.feature.geometry.coordinates[1];

    ev.feature.geometry.coordinates[0] = positionDeplace.lng; //update de la geometry à partir de la nouvelle position
    ev.feature.geometry.coordinates[1] = positionDeplace.lat;

    var matriculeOld = ev.feature.properties.matricule;
    var idBatiment = ev.feature.properties.id_batiment;

    var params = {
        'featurePoint': JSON.stringify(ev.feature),
        'featurePolyAvant': JSON.stringify(ueLayerAvant),
        'featurePolyApres': JSON.stringify(ueLayerApres),
        'municipalite': municipalite

    };
    $.ajax({
        type: "POST",
        url: "/gestion-roles/tenue-a-jour/operation-ue/batiment-move/",
        data: params,
        dataType: 'json',
        success: function (response) {

            $.each(response.features, function (k, v) {
                if (v.properties.matricule != '') {
                    var matriculeNew = v.properties.matricule;
                    var lotNew = v.properties.lot;

                    updateBatimentLayer(matriculeOld, matriculeNew, lotNew, idBatiment);
                    refreshTableApresOperationCadastrale();
                    activerSauvegarde();

                } else {
                    infos.ajouterMessageToast({
                        message: "Votre bâtiment est à l'extérieur de l'unité d'évaluation d'origine",
                        messageDuree: 1500,
                        messageCouleur: 'red'
                    }); //1500 = 1,5 secondes
                    lastPosition(ev, lat, lng);
                }
            });
        }
    });

}

function matriculeMove(ev, featurePoly, municipalite) {

    var positionDeplace = ev.getLatLng();

    var lng = ev.feature.geometry.coordinates[0];
    var lat = ev.feature.geometry.coordinates[1];

    ev.feature.geometry.coordinates[0] = positionDeplace.lng; //update de la geometry à partir de la nouvelle position
    ev.feature.geometry.coordinates[1] = positionDeplace.lat;

    var matriculeOld = ev.feature.properties.matricule;
    var params = {
        'featurePoint': JSON.stringify(ev.feature),
        'featurePoly': JSON.stringify(featurePoly),
        'municipalite': municipalite
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/tenue-a-jour/operation-ue/matricule-move/",
        data: params,
        dataType: 'json',
        success: function (response) {
            //si matricule différent de null
            // On remplace le matricule
            $.each(response.features, function (k, v) {
                if (v.properties.matricule != '') {
                    var matriculeNew = v.properties.matricule;
                    updateLotLayer(matriculeOld, matriculeNew);
                    updateMatriculeLayer(matriculeOld, matriculeNew);
                    updateBatimentLayer(matriculeOld, matriculeNew);
                    refreshTableApresOperationCadastrale();
                    activerSauvegarde();

                } else {
                    // on repositionne à l'origine avec um message toast
                    infos.ajouterMessageToast({
                        message: "Votre matricule est à l'extérieur de l'unité d'évaluation",
                        messageDuree: 1500,
                        messageCouleur: 'red'
                    }); //1500 = 1,5 secondes
                    lastPosition(ev, lat, lng);
                }
            });
        }
    });
}

function lastPosition(ev, lat, lng) {

    // mise à jour la position
    var newLatLng = new L.LatLng(lat, lng);
    ev.setLatLng(newLatLng);
    // mise à jour des attribut
    var position = ev.getLatLng();
    ev.feature.geometry.coordinates[0] = position.lng; //update de la geometry à partir de la nouvelle position
    ev.feature.geometry.coordinates[1] = position.lat;

}

function updateLotLayer(matriculeOld, matriculeNew) {

    var lotLayer = map_apres._lotLayer;
    if (lotLayer) {
        lotLayer.eachLayer(function (layer) {
            if (layer.feature.properties.matricule == matriculeOld) {
                layer.feature.properties.matricule = matriculeNew;
            }
        });
    }
}

function updateMatriculeLayer(matriculeOld, matricule_new) {
    var markerLayer = map_apres._markerLayer;

    if (markerLayer) {
        markerLayer.eachLayer(function (layer) {

            if (layer.feature.properties.featureClass == 'mat_mat_cr_t') {
                if (layer.feature.properties.matricule == matriculeOld) {
                    layer.feature.properties.matricule = matricule_new;
                    layer.unbindLabel();
                    layer.bindLabel(matricule_new);
                }
            }

        });
    }
}

function updateBatimentLayer(matriculeOld, matriculeNew, lotNew, id_batiment) {
    var markerLayer = map_apres._markerLayer;
    if (markerLayer) {
        markerLayer.eachLayer(function (layer) {

            if (layer.feature.properties.featureClass == 'batiment') {
                if (layer.feature.properties.matricule == matriculeOld) {
                    if (layer.feature.properties.id_batiment == id_batiment) {
                        layer.feature.properties.matricule = matriculeNew;
                        //optionel
                        if (lotNew) {
                            layer.feature.properties.lot = lotNew;
                        }
                    }
                }
            }

        });
    }
}

function findLotLayerAvant() {
    var lotLayer = map_avant._lotLayer;
    return lotLayer.toGeoJSON(15);
}

function findLotLayerApres() {
    var lotLayer = map_apres._lotLayer;
    return lotLayer.toGeoJSON(15);
}


function deleteBatimentLayerApres() {
    var markerLayer = map_apres._markerLayer;

    markerLayer.eachLayer(function (layer) {
        if (layer.feature.properties.featureClass == 'batiment') {
            markerLayer.removeLayer(layer);
        }
    });

}


function findBatimentLayerApres() {
    var markerLayer = map_apres._markerLayer;
    var markerLayerCopy = jQuery.extend(true, {}, markerLayer);

    markerLayerCopy.eachLayer(function (layer) {
        if (layer.feature.properties.featureClass != 'batiment') {
            var id = layer._leaflet_id;
            delete markerLayerCopy._layers[id];
        }
    });

    return markerLayerCopy.toGeoJSON(15);
}

function findMatriculeLayerApres() {
    var markerLayer = map_apres._markerLayer;
    var markerLayerCopy = jQuery.extend(true, {}, markerLayer);

    markerLayerCopy.eachLayer(function (layer) {
        if (layer.feature.properties.featureClass != 'mat_mat_cr_t') {
            var id = layer._leaflet_id;
            delete markerLayerCopy._layers[id];
        }
    });


    return markerLayerCopy.toGeoJSON(15);
}

function findUeFeatureApres(matricule) {

    var lotLayer = map_apres._lotLayer;
    var lotLayerCopy = jQuery.extend(true, {}, lotLayer); //On prend un copy de l'objet pour ne pas l'altérer

    lotLayerCopy.eachLayer(function (layer) {
        if (layer.feature.properties.matricule != matricule) {
            //delete de l'object en javascript
            var id = layer._leaflet_id;
            delete lotLayerCopy._layers[id];
        }
    });

    return lotLayerCopy.toGeoJSON(15);
}

function natureXMatricule(matricule) {

    var listNature = '';
    var lotLayer = map_apres._lotLayer;


    if (lotLayer) {

        var matBreak = '';
        lotLayer.eachLayer(function (layer) {

            if (layer.feature.properties.matricule == matricule) {

                if (matricule != matBreak) {

                    //itere ["Nouvelle unité d'évaluation (création)", "Subdivision de lot"]
                    $.each(layer.feature.properties.nature, function (index, value) {
                        listNature += value.description + '<br>';
                    });
                }
                matBreak = matricule;
                // pas de break disponible
            }
        });
    }

    return listNature;
}

function lotXMatricule(matricule) {

    var listLot = '';
    var lotLayer = map_apres._lotLayer;
    if (lotLayer) {
        lotLayer.eachLayer(function (layer) {
            if (layer.feature.properties.matricule == matricule) {
                //listLot += layer.feature.properties.lot + '<br>';
                listLot += layer.feature.properties.lot.split('/')[1] + '<br>';
            }
        });
    }

    return listLot;
}

function lotXMatriculeList(matricule) {

    var listLot = [];
    var lotLayer = map_apres._lotLayer;
    if (lotLayer) {
        lotLayer.eachLayer(function (layer) {
            if (layer.feature.properties.matricule == matricule) {
                listLot.push(layer.feature.properties.lot);
            }
        });
    }

    return listLot;
}

function batimentXMatricule(matricule) {

    var listBatiment = '';
    var markerLayer = map_apres._markerLayer;


    if (markerLayer) {
        markerLayer.eachLayer(function (layer) {

            if (layer.feature.properties.featureClass == 'batiment') {
                if (layer.feature.properties.matricule == matricule) {
                    listBatiment += layer.feature.properties.no_batiment + '<br>';
                }
            }
        });
    }

    return listBatiment;
}

function refreshMap(map) {
    map.eachLayer(function (layer) {
        map.removeLayer(layer);
        map.addLayer(layer);
        //layer.redraw();
    });
}

function cadastreAddMapAvant() {

    $('#carte-avant').html('').append('<div id="map-avant"></div>');
    var hauteur = 400; //550
    $('#map-avant').css("height", hauteur + "px");


}


function cadastreAddMapCreationMatricule() {

    $('#carte-apres').html('').append('<div id="map-creation-matricule"></div>');
    var hauteur = 400; //550
    $('#map-creation-matricule').css("height", hauteur + "px");

}

function cadastreAddMapApres() {
    $('#carte-apres').empty().append('<div id="lsidebar"></div><div id="map-controls-apres" class="map-controls-container map-controls-container-alt"></div><div id="map-apres" class="leaflet-container-alt"> </div>');
    var hauteur = 400; //550
    $('#map-apres').css("height", hauteur + "px");
}

function findUeSelectionAvant() {
    var matriculeLayerSelection = map_avant._geojsonLayer;
    var listUeSelect = [];
    if (matriculeLayerSelection) {
        matriculeLayerSelection.eachLayer(function (layer) {
            listUeSelect.push(layer.feature.properties.id_ue);
        });
    }
    return listUeSelect;
}

function ueCreationIsValid() {

    var message = '';
    var idMunicipalite = $('#wizard').attr('id-municipalite');
    var dateEvenement = $('#wizard').attr('date-evenement');
    var idTypeEvenement = $('#wizard').attr('id-type-evenement');
    var idEvenement = $('#wizard').attr('id-evenement');

    //On récupère la geometrie des polygonnes sélectionnnés
    var lotLayerSelect = map_apres._geojsonLotMultipleLayer;
    var ueTouche = lotLayerSelect.toGeoJSON(15);

    var params = {
        'ueTouche': JSON.stringify(ueTouche),
        'idMunicipalite': idMunicipalite,
        'dateEvenement': dateEvenement,
        'idTypeEvenement': idTypeEvenement,
        'idEvenement': idEvenement
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/tenue-a-jour/operation-ue/ue-creation-is-valid/",
        data: params,
        async: false,
        dataType: 'html',
        success: function (response) {
            // si même proprio et pourcentage

            if (response == 'ok') {
                message = 'ok';
            }
            if (response == 'mutation_ouverte') {
                message = "Mutation en cours sur une des unités d'évaluation";
            }

            if (response == 'pas_ok') {
                message = 'Propriétaires ou pourcentages non valides';
            }

        },
        error: function (xhr, ajaxOptions, thrownError) {

            infos.ajouterMessageToast({
                message: 'Une erreur s\'est produite. Contactez un administrateur.',
                messageDuree: 0
            });

            var response = {reponse: 'error'};
            callback(response);
        }
    });
    return message;
}


function ueCreation() {
    messageToastCompteur = 0;
    var message_erreur = '';
    var dateEvenement = $('#wizard').attr('date-evenement');
    var idTypeEvenement = $('#wizard').attr('id-type-evenement');
    var idEvenement = $('#wizard').attr('id-evenement');

    var listLotSelect = findLotSelectionApres();

    //On s'assure qu'il au moins un lot de sélectionné
    if (listLotSelect.length == 0) {
        infos.ajouterMessageToast({
            message: 'Veuillez sélectionner un lot',
            messageDuree: 1500,
            messageCouleur: 'red'
        }); //1500 = 1,5 secondes
    } else {

        message_erreur = ueCreationIsValid();
        if (message_erreur == 'ok') {

            //On ajoute le lot au gson de _lot_layer et le batiment marker_layer si pas présent
            addLotSelectionApres(listLotSelect, idEvenement, dateEvenement, idTypeEvenement);

            var listMatriculeSelect = findMatriculeSelectionApres(listLotSelect);

            var ueTouche = findLotLayerSelectionApres(listLotSelect, listMatriculeSelect);

            var idMunicipalite = $('#wizard').attr('id-municipalite');
            var params = {
                'ueTouche': JSON.stringify(ueTouche),
                'idMunicipalite': idMunicipalite,
                'idEvenement': idEvenement,
                'dateEvenement': dateEvenement
            };

            $.ajax({
                type: "POST",
                url: "/gestion-roles/tenue-a-jour/operation-ue/ue-creation/",
                data: params,
                async: true,
                dataType: 'json',
                success: function (response) {


                    $.each(response.features, function (k, v) {

                        var matriculeNew = v.properties.matricule;
                        var nature = v.properties.nature;
                        var colorNew = v.properties.color;
                        var colorRgbNew = v.properties.color_rgb;
                        var listLot = v.properties.lot.split(',');
                        //On update le champ matricule des lots touché (lot --- new_matricule)
                        updateUeTouche(matriculeNew, listLot, nature, colorNew, colorRgbNew);
                        //on update le champ matricule des batiments   (lot --- new_matricule)
                        updateBatimentTouche(matriculeNew, listLot);
                    });

                    //On supprime les matricules
                    deleteMatriculeTouche(listMatriculeSelect);

                    //On ajoute les matricule
                    map_apres._markerLayer.addData(response);

                    // On update les tableaux
                    refreshTableAvantOperationCadastrale();
                    refreshTableApresOperationCadastrale();

                    map_apres.removeLayer(map_apres._geojsonLotMultipleLayer);
                    map_apres._initGeojsonLayerMultiple();

                    //refreshMap(map_apres);
                }

            });

        } else {
            infos.ajouterMessageToast({
                message: message_erreur,
                messageDuree: 1500,
                messageCouleur: 'red'
            });
            //infos.ajouterMessageToast({message: 'Veuillez sélectionner un lot', messageDuree: 1500, messageCouleur: 'red'});//1500 = 1,5 secondes
        }

    }
}


function findLotSelectionApres() {

    var LotLayerSelection = map_apres._geojsonLotMultipleLayer;
    var listLotSelect = [];
    if (LotLayerSelection) {
        LotLayerSelection.eachLayer(function (layer) {
            if (jQuery.inArray(layer.feature.properties.lot, listLotSelect) == -1) {

                //var matriculeLot = {id:layer.feature.properties.matricule + layer.feature.properties.lot ,matricule:layer.feature.properties.matricule, lot:layer.feature.properties.lot};
                //listLotSelect.push(matriculeLot);
                listLotSelect.push(layer.feature.properties.lot);

            }
        });
    }
    return listLotSelect;
}

function addLotSelectionApres(listLotSelect, idEvenement, dateEvenement, idTypeEvenement) {

    var dateEvenementAvant = '';
    var dateEvenementApres = '';

    var listAvant = creationListAvantApres(idEvenement, dateEvenement, 'avant', idTypeEvenement);
    $.each(listAvant, function (index, id_ue) {
        dateEvenementAvant = id_ue.date_evenement;
    });

    var listApres = creationListAvantApres(idEvenement, dateEvenement, 'apres', idTypeEvenement);
    $.each(listApres, function (index, id_ue) {
        dateEvenementApres = id_ue.date_evenement;
    });

    // trouve les lots de lot_layer
    var lotLayer = map_apres._lotLayer;
    var listLot = [];
    lotLayer.eachLayer(function (layer) {
        listLot.push(layer.feature.properties.lot);
    });

    //trouve le ou les lot pas dans lot_layer
    var listLotAutre = $.grep(listLotSelect, function (el) {
        return $.inArray(el, listLot) == -1;
    });

    //creer un liste de matricule à partir geojsonLotMultipleLayer
    var geojsonLotMultipleLayer = map_apres._geojsonLotMultipleLayer;
    var listMatriculeAutre = [];
    geojsonLotMultipleLayer.eachLayer(function (layer) {
        if (jQuery.inArray(layer.feature.properties.lot, listLotAutre) != -1) {
            listMatriculeAutre.push(layer.feature.properties.matricule);
        }
    });

    //ajoute le ou les autres UE
    if (listMatriculeAutre.length != 0) {
        map_apres.LotFeatureByAttribute(listMatriculeAutre, false, false, 'num_lot', false, idEvenement, idTypeEvenement, listMatriculeAutre);
        map_apres.markerFeatureByAttribute(listMatriculeAutre, false, false, 'batiment', false, dateEvenementAvant, dateEvenementApres, idTypeEvenement);
        map_apres.markerFeatureByAttribute(listMatriculeAutre, false, false, 'mat_mat_cr_t', false);
        //map_avant.LotFeatureByAttribute(listLotAutre, false, false, 'num_lot', false, idEvenement, idTypeEvenement); // polygon de lot composant l'unité d'évaluation
        map_avant.LotFeatureByAttribute(listMatriculeAutre, false, false, 'matricule', false, idEvenement, idTypeEvenement); // polygon de lot composant l'unité d'évaluation


    }

}

function findMatriculeSelectionApres(listLotSelect) {

    var lotLayer = map_apres._lotLayer;
    // On creer un array de matricule
    var listMatricule = [];
    if (lotLayer) {
        lotLayer.eachLayer(function (layer) {
            if (jQuery.inArray(layer.feature.properties.lot, listLotSelect) != -1) {
                if (jQuery.inArray(layer.feature.properties.matricule, listMatricule) == -1) {
                    listMatricule.push(layer.feature.properties.matricule);
                }
            }
        });
    }
    return listMatricule;
}


function findLotLayerSelectionApres(listLotSelect, listMatriculeSelect) {

    var lotLayer = map_apres._lotLayer;
    var lotLayerCopy = jQuery.extend(true, {}, lotLayer); //On prend un copy de l'objet pour ne pas l'altérer

    lotLayerCopy.eachLayer(function (layer) {
        if (jQuery.inArray(layer.feature.properties.matricule, listMatriculeSelect) != -1) {
            if (jQuery.inArray(layer.feature.properties.lot, listLotSelect) != -1) {
                lotLayerCopy._layers[layer._leaflet_id].feature.properties.matricule = '0000-00-0000';
            }
        } else {
            delete lotLayerCopy._layers[layer._leaflet_id];
        }
    });

    return lotLayerCopy.toGeoJSON(15);
}

function updateUeTouche(matriculeNew, listLot, nature, colorNew, colorRgbNew) {

    var lotLayer = map_apres._lotLayer;

    lotLayer.eachLayer(function (layer) {
        if (jQuery.inArray(layer.feature.properties.lot, listLot) != -1) {
            layer.feature.properties.id_ue = '';
            layer.feature.properties.matricule = matriculeNew;

            //layer.feature.properties.lot = matriculeNew + '/' + layer.feature.properties.lot.split('/')[1];

            layer.feature.properties.nature = nature;
            layer.feature.properties.color = colorNew;
            layer.feature.properties.color_rgb = colorRgbNew;
            layer.setStyle({fillColor: colorNew});


        }
    });
}

function updateBatimentTouche(matriculeNew, listLot) {

    var markerLayer = map_apres._markerLayer;

    // #5924, ajout du ou des batiment(s) lors d'une création, on récupère la fonction batimentMove pour mettre à jour les autres batiments de la mutation ou de l'opération UE
    var listLotSansMatricule = [];
    $.each(listLot, function (key, value) {
        listLotSansMatricule.push(value.split('/')[1]);
    });

    if (markerLayer) {
        markerLayer.eachLayer(function (layer) {
            if (layer.feature.properties.featureClass == 'batiment') {


                if (jQuery.inArray(layer.feature.properties.lot, listLot) != -1) {
                    layer.feature.properties.matricule = matriculeNew;
                }

                var municipalite = layer.feature.properties.municipalite;
                var lotLayerAvant = findLotLayerAvant();
                var lotLayerApres = findLotLayerApres();
                batimentMove(layer, lotLayerAvant, lotLayerApres, municipalite);
            }
        });
    }
}

function deleteMatriculeTouche(listMatricule) {

    var markerLayer = map_apres._markerLayer;
    if (markerLayer) {
        markerLayer.eachLayer(function (layer) {
            if (layer.feature.properties.featureClass == 'mat_mat_cr_t') {
                if (jQuery.inArray(layer.feature.properties.matricule, listMatricule) != -1) {
                    markerLayer.removeLayer(layer);
                }
            }
        });
    }
}

function activerSauvegarde() {
    $('#table-apres-operation-cadastrale').attr('modifie', 'True');
    $('button[data-type="save"]').prop("disabled", false);
}

function desactiverSauvegarde() {
    $('#table-apres-operation-cadastrale').attr('modifie', 'False');
    $('button[data-type="save"]').prop("disabled", true);


}


function valid_save_mutation() {

    var save_mutation = false;
    var lotLayer = map_apres._lotLayer;

    lotLayer.eachLayer(function (layer) {
        if (layer.feature.properties.id_ue != '') {
            save_mutation = true;
        }
    });

    return save_mutation;
}


function valide_matricule_unique(idMunicipalite, lotLayer, dateEvenement) {

    var reponse = '';
    var params = {
        'idMunicipalite': idMunicipalite,
        'lotLayer': JSON.stringify(lotLayer),
        'dateEvenement': dateEvenement,
        'id_processus': $('#wizard').attr('id-processus'),
        'id_type_evenement': $('#wizard').attr('id-type-evenement')
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/tenue-a-jour/operation-ue/valide-matricule-unique/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            reponse = response;
        }
    });
    return reponse;
}


function valideOperationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, callback, estCadastreVertical) {
    if (typeof(estCadastreVertical) == 'undefined') estCadastreVertical = false;

    if (estCadastreVertical) {
        operationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, callback, 0, estCadastreVertical);
        return false;
    }

    var estVentePartieLot = ($('.step-pane.active [name=checkbox-ue-tous]').length > 0);
    if (estVentePartieLot) {
        operationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, callback, 0, estCadastreVertical);
        return;
    }

    var lotLayer = findLotLayerApres();

    var params = {
        'idEvenement': idEvenement,
        'idTypeEvenement': idTypeEvenement,
        'lotLayer': JSON.stringify(lotLayer)
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/tenue-a-jour/operation-ue/valide-operation-ue-save/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {

            if (response[0]['id_ue'] !== null) {

                if (response[0]['id_ue'] === 'creation_seulement') {

                    fenetreModal.modalMessage({
                        titre: "Voulez-vous vraiment juste de nouvelle(s) création(s) ?",
                        sansX: true,
                        texteExplicatif: "",
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action: function () {

                                    operationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, callback);

                                }
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                    response.reponse = 'ok';
                                    callback(response);
                                }
                            }
                        }
                    });


                } else {

                    fenetreModal.modalMessage({
                        titre: "L'unité d'évaluation (" + $('#wizard').attr('id-ue') + ") en cours sera supprimée, êtes-vous certain ?",
                        sansX: true,
                        texteExplicatif: "",
                        boutons: {
                            "Oui": {
                                label: " Oui ",
                                id: "",
                                class: "btn btn-success",
                                action: function () {
                                    if (response) {
                                        var idTypeEvenementAvant = $('#wizard').attr('id-type-evenement');
                                        var idEvenement = response[0]['id_evenement'];
                                        var idTypeEvenement = response[0]['id_type_evenement'];

                                        operationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, function (reponse) {
                                            if (reponse.reponse == 'ok') {
                                                fenetreModal.fermerModal('modal-wizard-evenement');
                                                tenueAJourModal.ouvrirWizardEvenement(idEvenement);
                                            }
                                            callback(reponse);
                                        }, idTypeEvenementAvant);

                                    }
                                }
                            },
                            "Non": {
                                label: " Non ",
                                id: "",
                                class: "btn",
                                action: function () {
                                    response.reponse = 'ok';
                                    callback(response);
                                }
                            }
                        }
                    });
                }


            } else {
                operationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, callback);
            }

        }
    });

}


function operationUeSave(idMunicipalite, idEvenement, dateEvenement, idTypeEvenement, callback, idTypeEvenementAvant, estCadastreVertical) {
    wait.start('contenu');

    if (typeof(idTypeEvenementAvant) == 'undefined') idTypeEvenementAvant = 0;
    if (typeof(estCadastreVertical) == 'undefined') estCadastreVertical = false;

    var estVentePartieLot = ($('.step-pane.active [name=checkbox-ue-tous]').length > 0);
    var uesPartieLot = [];
    var batimentLayer;
    var lotLayer;
    var matriculeLayer;

    if (estCadastreVertical) {

        var tableauLotsAvant = $('#exp-ue-lots-cadastre-vertical').find('[id="mutation-ue-lots-cadastre-vertical"]');
        var tableauLotsApres = $('#exp-ue-lots-cadastre-vertical-apres').find('[id="mutation-ue-lots-cadastre-vertical"]');

        var lotsCadastreVerticalAvant = [];
        var lotsCadastreVertical = [];

        $.each(tableauLotsAvant, function () {
            var lot = {};
            lot.lot = $(this).find('[name="lot_no_lot"]').text();
            lot.matricule_source = $(this).find('[name="lot_matricule"]').text();
            lot.matricule = lot.matricule_source;
            lot.id_ue_source = parseInt($(this).find('[name="lot_id_ue"]').text());
            lot.id_ue_destination = lot.id_ue_source;
            lot.nature = [];
            lotsCadastreVerticalAvant.push(lot);
        });

        $.each(tableauLotsApres, function () {
            var ligne = $(this);

            var listeIdUeDestination = ligne.find('[name="lot_id_ue_destination"]').select2('val');
            $.each(listeIdUeDestination, function(index, valeur) {
                var lot = {};
                lot.lot = ligne.find('[name="lot_no_lot"]').text();

                lot.matricule_source = ligne.find('[name="lot_matricule_source"]').text();
                var listeMatricule = ligne.find('[name="lot_matricule"]').html().split('<br>');
                lot.matricule = listeMatricule[index];

                lot.id_ue_source = parseInt(ligne.find('[name="lot_id_ue_source"]').text());
                lot.id_ue_destination = parseInt(valeur);
                var idUeCalculNb = lot.id_ue_source == lot.id_ue_destination ? lot.id_ue_source : lot.id_ue_destination;

                var nbLotsApres = tableauLotsApres.find('[name="lot_id_ue_destination"]').filter(function () {
                    return $.inArray(idUeCalculNb.toString(), $(this).select2('val')) != -1;
                }).closest('[id="mutation-ue-lots-cadastre-vertical"]').length;

                var nbLotsAvant = tableauLotsApres.find('[name="lot_id_ue_source"]').filter(function () {
                    return $(this).text() == idUeCalculNb;
                }).closest('[id="mutation-ue-lots-cadastre-vertical"]').length;

                lot.nature = [];
                var nature = {};
                if (nbLotsApres > nbLotsAvant /*&& lot.id_ue_source == lot.id_ue_destination*/) {
                    nature = {
                        description: "Addition d\'une partie de terrain",
                        no: 83,
                    };
                } else if (nbLotsApres < nbLotsAvant /*&& lot.id_ue_source != lot.id_ue_destination*/) {
                    nature = {
                        description: "Soustraction d\'une partie de terrain",
                        no: 81,
                    };
                }
                if (Object.keys(nature).length) {
                    lot.nature.push(nature);
                }
                lotsCadastreVertical.push(lot);
            });
        });

        var lotLayerAvant = {type: 'FeatureCollection', features: []};
        $.each(lotsCadastreVerticalAvant, function (idx, lot) {
            lotLayerAvant.features.push(getFeatureCadastreVertical(lot));
        });

        lotLayer = {type: 'FeatureCollection', features: []};
        $.each(lotsCadastreVertical, function (idx, lot) {
            lotLayer.features.push(getFeatureCadastreVertical(lot));
        });

        batimentLayer = {
            type: 'FeatureCollection',
            features: [],
        };
        matriculeLayer = {
            type: 'FeatureCollection',
            features: [],
        };

        function getFeatureCadastreVertical(lot) {
            var feature = {
                type: "Feature",
                geomwetry: {},
                properties: {
                    id_ue: lot.id_ue_destination,
                    id_ue_creation: lot.id_ue_creation,
                    matricule: lot.matricule,
                    lot: lot.matricule_source +'/' + lot.lot,
                    nature: lot.nature,
                    lat: '',
                    lng: '',
                    color: '',
                    color_rgb: [],
                    information_ue: []
                },
                id_ue: lot.id_ue_source
            };
            return feature;
        }
    } else if (estVentePartieLot) {
        var tableauUEs = $('.step-pane.active').find('[id="mutation-ue-partie-lot"]');

        $.each(tableauUEs, function () {
            var ligne = $(this);

            var ue = {};
            ue.id_ue = ligne.find('[name="lot_id_ue"]').text();
            ue.bool_ue_inclus = (ligne.find('[name="bool_ue_inclus"]:checked').length > 0);

            uesPartieLot.push(ue);
        });
    } else {
        lotLayerAvant = findLotLayerAvant();
        lotLayer = findLotLayerApres();
        batimentLayer = findBatimentLayerApres();
        matriculeLayer = findMatriculeLayerApres();
    }

    // séparation de la logique pour éviter duplication de code
    function operationUeSaveApresTestMatricule(){
        var params = {
            'idMunicipalite': idMunicipalite,
            'idEvenement': idEvenement,
            'dateEvenement': dateEvenement,
            'idTypeEvenement': idTypeEvenement,
            'lotLayer': JSON.stringify(lotLayer),
            'batimentLayer': JSON.stringify(batimentLayer),
            'matriculeLayer': JSON.stringify(matriculeLayer),
            'est_cadastre_vertical': estCadastreVertical,
            'est_vente_partie_lot': estVentePartieLot,
            'uesPartieLot': JSON.stringify(uesPartieLot)
        };
        params['lotLayerAvant'] = JSON.stringify(lotLayerAvant);

        if (idTypeEvenementAvant) {
            params.id_type_evenement_avant = idTypeEvenementAvant;
        }

        $.ajax({
            type: "POST",
            url: "/gestion-roles/tenue-a-jour/operation-ue/save/",
            data: params,
            async: true,
            dataType: 'json',
            success: function (response) {

                if (response.date_evenement) {
                    dateEvenement = response.date_evenement;
                    $('#wizard').attr('date-evenement', dateEvenement);
                }

                if (!estCadastreVertical && !estVentePartieLot) {
                    //On supprime les batiment
                    deleteBatimentLayerApres();

                    // Reload les markers de batiment
                    var dateEvenementAvant = '';
                    var dateEvenementApres = '';
                    var listMatriculeAvant = [];
                    var listMatriculeApres = [];

                    var listAvant = creationListAvantApres(idEvenement, dateEvenement, 'avant', idTypeEvenement);
                    $.each(listAvant, function (index, id_ue) {
                        listMatriculeAvant.push(id_ue.matricule);
                        dateEvenementAvant = id_ue.date_evenement;
                    });

                    var listApres = creationListAvantApres(idEvenement, dateEvenement, 'apres', idTypeEvenement);
                    $.each(listApres, function (index, id_ue) {
                        listMatriculeApres.push(id_ue.matricule);
                        dateEvenementApres = id_ue.date_evenement;
                    });

                    map_apres.markerFeatureByAttribute(listMatriculeAvant, false, false, 'batiment', false, dateEvenementAvant, dateEvenementApres, idTypeEvenement);

                    //id_ue_creation

                    map_apres.LotFeatureByAttribute(listMatriculeApres, true, false, 'num_lot', false, idEvenement, idTypeEvenement, listMatriculeAvant);

                    refreshTableApresOperationCadastrale();

                    refreshDatatables();

                    $('#table-apres-operation-cadastrale').attr('modifie', 'False');
                }
                else {
                    if (estCadastreVertical) {
                        tableauLotsApres.attr('modifie', false);
                    }
                }

                // On désactive le bouton save
                $('button[data-type="save"]').prop("disabled", true);

                var response = {reponse: 'ok'};

                infos.ajouterMessageToast({
                    message: 'Sauvegarde réussie',
                    messageDuree: 500,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                });

                callback(response);
                wait.stop('contenu', false);

            },
            error: function (xhr, ajaxOptions, thrownError) {
                wait.stop('contenu', false);
                var message = "Une erreur s'est produite. Contactez un administrateur.";
                if (xhr.responseJSON) {
                    message = xhr.responseJSON;
                }
                infos.ajouterMessageToast({
                    message: message,
                    messageDuree: 0
                });

                var response = {reponse: 'error'};
                callback(response);
            }
        });


    }

    //On valide que pour une mutation, on conserve tjs un id_ue existant
    //todo, le cas du matricule est vague
    var bool_valide_matricule_ok = true;
    var valide_matricule;
    if (!estVentePartieLot) {
        valide_matricule = valide_matricule_unique(idMunicipalite, lotLayer, dateEvenement);
        bool_valide_matricule_ok = (valide_matricule[0]['matricule'] == '');
    }

    if (bool_valide_matricule_ok) {
        operationUeSaveApresTestMatricule();
    } else {

        let message_avertissement = "Le nouveau matricule "+ valide_matricule[0]['matricule'] +" proposé a déjà été utilisé dans cette municipalité et cela pourrait poser un problème lors de son intégration dans le système de taxation de la municipalité. Au besoin, vous pouvez déplacer légèrement le centroïde sur la carte de droite afin de générer un nouveau matricule différent.";
        message_avertissement += "<br>Voulez-vous quand même procéder?";
        fenetreModal.modalMessage({
            titre: "Matricule déjà utilisé",
            sansX: true,
            texteExplicatif: message_avertissement,
            boutons: {
                "Oui": {
                    label: " Oui ",
                    id: "",
                    class: "btn btn-success",
                    action: function () {
                        operationUeSaveApresTestMatricule();
                    }
                },
                "Non": {
                    label: " Non ",
                    id: "",
                    class: "btn",
                    action: function () {
                        fenetreModal.fermerModalAlerteDivs();
                        wait.stop('contenu', false);
                    }
                }
            }
        });

    }
}

function isOperationUE() {

    var operationUeFait = false;
    var lotLayer = map_apres._lotLayer;

    lotLayer.eachLayer(function (layer) {
        if (layer.feature.properties.nature.length != 0) {
            operationUeFait = true;
        }
    });
    return operationUeFait;
}


function cadastreInitMapCreationMatricule(idMunicipalite, bbox, div_map, idMap, dateEvenement, idTypeEvenement, idProcessus, isModeReadOnly) {

    try {
        map_apres.remove();
        map_apres.removeLayer(googleStreetsApres);
    } // Ceci plante dans i.e. alors...
    catch (err) {
    }


    map_apres = new L.Map(div_map, {});

    osm = new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 23
    });

    map_apres.addLayer(googleStreetsApres);

    var groupeBaseExpanded = $("#leafletCouchesBaseExpanded").val() == 'true';

    var baseMaps = [{
        groupName: "Carte de base",
        expanded: groupeBaseExpanded,
        layers: {
            'OpenStreetMap': osm,
            'Google Map': googleStreetsApres,
            'Google Hybride': googleHybridApres,
            'Google Sat': googleSatApres,
            'Google Terrain': googleTerrainApres
        }
    }];

    var overlays = [{}];

    var options = {
        container_width: "250px",
        group_maxHeight: "200px",
        container_maxHeight: "600px",
    };


    var control = L.Control.styledLayerControl(baseMaps, overlays, options);
    map_apres.addControl(control);
    $("#map-controls-apres").append(control.getContainer());

    //ON OBTIENT L'URL DE GEOSERVER DEPUIS LE SETTINGS
    var urlGeoserver = $('#urlGeoserver').val();

    //ON CONFIGURE AUTOMATIQUEMENT LES LAYERS DE LA MAP DEPUIS LA BD À L'AIDE DE NOTRE PLUGIN LEAFLET
    map_apres = map_apres.buildEvbMap({
        idMap: idMap,
        zoomToMapExtent: true,
        controlLayers: control,
        urlGeoserver: urlGeoserver,
        urlOrthosGeoserver: $('#urlOrthosGeoserver').val(),
        idMunicipalite: idMunicipalite,
        bbox: bbox,
        dateEvenement: dateEvenement,
        callback: function () {

            var idEvenement = $('#wizard').attr('id-evenement');

            if (idEvenement != '') {


                var dateEvenement = $('#wizard').attr('date-evenement');
                var listApres = creationListAvantApres(idEvenement, dateEvenement, 'apres', idTypeEvenement);
                //
                var listMatriculeApres = [];
                $.each(listApres, function (index, id_ue) {
                    listMatriculeApres.push(id_ue.matricule);
                    dateEvenementApres = id_ue.date_evenement;
                });
                map_apres.markerFeatureByAttribute(listMatriculeApres, false, false, 'mat_mat_cr_t', false);
                var listMatriculeAvant = [];
                map_apres.LotFeatureByAttribute(listMatriculeApres, true, true, 'num_lot', false, idEvenement, idTypeEvenement, listMatriculeAvant);
                refreshTableApresOperationCadastrale(true);

                desactiverSauvegarde();

            }
            else {
                wait.stop('contenu', false);
            }

            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));
        }
    });

    map_apres.EnableMarkerFeatureByAttribute({
        url: '/gestion-roles/tenue-a-jour/operation-ue/marker.json/',
        zoomToFeature: true,
        idMunicipalite: idMunicipalite,
        dateEvenement: dateEvenement,
        isModeReadOnly: isModeReadOnly,
        callbackBeforeSelect: function () {
        },
        callback: function (properties) {
        }
    });
    map_apres.EnableLotFeatureByAttribute({
        url: '/gestion-roles/tenue-a-jour/operation-ue/lot.json/',
        zoomToFeature: true,
        idMunicipalite: idMunicipalite,
        dateEvenement: dateEvenement,

        callbackBeforeSelect: function () {
        },
        callback: function (properties) {
        }
    });

    map_apres.whenReady(function() {
        init_layer_group_checkbox_and_layer_menu_styles();
    });


    if (!isModeReadOnly) {
        // L.easyButton('fa-refresh', function () {
        //     refreshMap(map_apres);
        // }, 'Rafraichir la carte').addTo(map_apres);

        var deplacementBail = $("#deplacement-bail").val();
        if (deplacementBail == 'True') {

            L.easyButton('fa-keyboard-o', function () {
                deleteCreationMatricule();
                ouvrirModalCreationMatriculeCoordonnees("Déplacement d'un bail à partir de coordonnées");
            }, "Déplacement d'un bail par coordonnées").addTo(map_apres);

        }else{

            L.easyButton('fa-crosshairs', function () {
            deleteCreationMatricule();
            map_apres.on('click', addMarker);
            }, 'Création matricule sur la carte').addTo(map_apres);

            L.easyButton('fa-keyboard-o', function () {
                deleteCreationMatricule();
                ouvrirModalCreationMatriculeCoordonnees("Création d'un matricule à partir de coordonnées");
            }, 'Création matricule par coordonnées').addTo(map_apres);

            L.easyButton('fa-file-text', function () {
                deleteCreationMatricule();
                ouvrirModalCreationMatriculeJson();
            }, "Création matricule à partir d'un nouveau lot").addTo(map_apres);
        }


    }

    desactiverSauvegarde();
}

function addMarker(e) {

    // Au lieu de passer une liste de matricule, on passe les coordonnées
    var listMatriculeApres = [e.latlng.lat, e.latlng.lng];
    map_apres.markerFeatureByAttribute(listMatriculeApres, false, false, 'matricule_creation', false);

    // Un seul à la fois
    map_apres.off('click');
    activerSauvegarde();

}


function ouvrirModalCreationMatriculeJson() {

    var vue = "/gestion-roles/tenue-a-jour/operation-ue/creation-matricule-json-modal/";
    var vueParams = {};

    fenetreModal.modalMessage({
        taille: 'grande',
        enteteTitre: "Création d'un matricule à partir d'un GeoJson",
        vueACharger: vue,
        vueAChargerParams: vueParams,
        sansX: true,
        boutons: {
            "Sauvegarder": {
                label: " Sauvegarder ",
                id: "",
                class: "btn btn-success",
                action: function () {

                    try {

                        var geoJson = $('#creation-matricule-json').val();
                        $('#creation-matricule-json-text').val(geoJson);

                        activerSauvegarde();
                    } catch (err) {
                        infos.ajouterMessageToast({
                            message: "Format du GeoJson invalide",
                            messageDuree: 2500,
                            messageCouleur: 'red'
                        }); //1500 = 1,5 secondes
                    }

                }
            },
            "Annuler": {
                label: " Annuler ",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModalAlerteDivs();
                }
            }
        }
    });

}

function ouvrirModalCreationMatriculeCoordonnees(enteteTitre) {

    var vue = "/gestion-roles/tenue-a-jour/operation-ue/creation-matricule-modal/";
    var vueParams = {};

    fenetreModal.modalMessage({
        taille: 'grande',
        enteteTitre: enteteTitre,
        vueACharger: vue,
        vueAChargerParams: vueParams,
        sansX: true,
        boutons: {
            "Sauvegarder": {
                label: " Sauvegarder ",
                id: "",
                class: "btn btn-success",
                action: function () {

                    var creationMatriculeLatitude = $('#creation-matricule-latitude').val();
                    var creationMatriculeLongitude = $('#creation-matricule-longitude').val();
                    // Au lieu de passer une liste de matricule, on passe les coordonnées
                    var listMatriculeApres = [creationMatriculeLatitude, creationMatriculeLongitude];
                    map_apres.markerFeatureByAttribute(listMatriculeApres, false, true, 'matricule_creation', false);
                    activerSauvegarde();
                    $('#table-apres-operation-cadastrale').attr('modifie', 'True');

                }
            },
            "Annuler": {
                label: " Annuler ",
                id: "",
                class: "btn",
                action: function () {
                    fenetreModal.fermerModalAlerteDivs();
                }
            }
        }
    });

}

function findCreationMatriculeLayerApres() {
    var markerLayer = map_apres._markerLayer;
    var markerLayerCopy = jQuery.extend(true, {}, markerLayer);

    markerLayerCopy.eachLayer(function (layer) {
        if (layer.feature.properties.featureClass != 'matricule_creation') {
            var id = layer._leaflet_id;
            delete markerLayerCopy._layers[id];
        }
    });


    return markerLayerCopy.toGeoJSON(15);
}

function deleteCreationMatricule() {

    var markerLayer = map_apres._markerLayer;
    if (markerLayer) {
        markerLayer.eachLayer(function (layer) {
            if (layer.feature.properties.featureClass == 'matricule_creation') {
                markerLayer.removeLayer(layer);
            }
        });
    }

    desactiverSauvegarde();

}


function creationMatriculeUeLot(idMunicipalite, dateEvenement, idTypeEvenement, callback) {

    wait.start('contenu');

    var creationMatriculeLayer = findCreationMatriculeLayerApres();
    var geoJson = $('#creation-matricule-json-text').val();
    var creationMatriculeLayerJson;
    if (geoJson != '') {
        creationMatriculeLayerJson = jQuery.parseJSON($('#creation-matricule-json-text').val());
    } else {
        creationMatriculeLayerJson = jQuery.parseJSON('{}');
    }

    var params = {
        'idMunicipalite': idMunicipalite,
        'dateEvenement': dateEvenement,
        'idTypeEvenement': idTypeEvenement,
        'creationMatriculeLayer': JSON.stringify(creationMatriculeLayer),
        'creationMatriculeLayerJson': JSON.stringify(creationMatriculeLayerJson)
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/tenue-a-jour/operation-ue/save-matricule-ue-lot/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {

            // idEvenement

            if (response[0].id_ue != '') {

                $('#wizard').attr('id-ue', response[0].id_ue);
                $('#exp-ue-id-ue').val(response[0].id_ue);

                var callbackEvenement = function (responseCallback) {
                    if (responseCallback.reponse != 'ok') {
                        callback(responseCallback);
                        return;
                    }

                    var idEvenement = $('#wizard').attr('id-evenement');

                    //On sauvegarde le bool_creation_matricule dans evenement
                    saveBoolCreationMatricule(callback, idEvenement);
                    //
                    var listApres = creationListAvantApres(idEvenement, dateEvenement, 'apres', idTypeEvenement);
                    //
                    var listMatriculeApres = [];
                    $.each(listApres, function (index, id_ue) {
                        listMatriculeApres.push(id_ue.matricule);
                        dateEvenementApres = id_ue.date_evenement;
                    });
                    //
                    map_apres.markerFeatureByAttribute(listMatriculeApres, false, false, 'mat_mat_cr_t', false);
                    //
                    // //id_ue_creation
                    //
                    var listMatriculeAvant = [];
                    map_apres.LotFeatureByAttribute(listMatriculeApres, true, false, 'num_lot', false, idEvenement, idTypeEvenement, listMatriculeAvant);
                    refreshTableApresOperationCadastrale(true);

                    desactiverSauvegarde();

                    var etapeOrdre = 2; // recharger l'étape 'Unité(s) d'évaluation'
                    $('#modal-step' + etapeOrdre).attr('recharger', 'oui');

                    var response = {reponse: 'ok'};
                    callback(response);

                };

                tenueAJourModal.saveEvenementParLocalisation(callbackEvenement);

            } else {
                infos.ajouterMessageToast({
                    message: "Vous ne pouvez pas créer une unité d'évaluation dans cette zone (matricule présent: " + response[0].matricule + ")",
                    messageDuree: 0,
                    messageCouleur: 'red'
                });

                deleteCreationMatricule();
                activerSauvegarde();

                var response = {reponse: 'error'};
                callback(response);


            }


        },
        error: function (xhr, ajaxOptions, thrownError) {
            infos.ajouterMessageToast({
                message: 'Une erreur s\'est produite. Contactez un administrateur.',
                messageDuree: 0
            });

            var response = {reponse: 'error'};
            callback(response);
        }


    });

}

function saveBoolCreationMatricule(callback, idEvenement) {

    var params = {
        'idEvenement': idEvenement
    };

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/operation-ue/save-bool-creation-matricule/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {

            callback(response);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            infos.ajouterMessageToast({
                message: 'Une erreur s\'est produite. Contactez un administrateur.',
                messageDuree: 0
            });
            var response = {reponse: 'error'};
            callback(response);
        }
    });
}

function getBoolCreationMatricule(idEvenement) {

    var params = {
        'idEvenement': idEvenement
    };
    var boolCreationMatricule;
    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/operation-ue/get-bool-creation-matricule/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            boolCreationMatricule = response[0].response;
        }
    });

    return boolCreationMatricule;
}

//15697
function saveDeplacementBail(idMunicipalite, dateEvenement, idTypeEvenement, idEvenement, idUe, callback) {

    var creationMatriculeLayer = findCreationMatriculeLayerApres();
    var geoJson = $('#creation-matricule-json-text').val();
    var creationMatriculeLayerJson = {};
    if (geoJson != '') {
        creationMatriculeLayerJson = jQuery.parseJSON($('#creation-matricule-json-text').val());
    }


    var params = {
        'idMunicipalite': idMunicipalite,
        'dateEvenement': dateEvenement,
        'idTypeEvenement': idTypeEvenement,
        'idEvenement': idEvenement,
        'idUe': idUe,
        'creationMatriculeLayer': JSON.stringify(creationMatriculeLayer),
        'creationMatriculeLayerJson': JSON.stringify(creationMatriculeLayerJson)
    };

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/operation-ue/deplacement-bail/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {

            if (response.sauvegarde !== 'ok') {

                infos.ajouterMessageToast({
                    message: response.msg,
                    messageDuree: 2500,
                    messageCouleur: 'red'
                }); //1500 = 1,5 secondes
                var response = {reponse: 'pas_ok'};
                callback(response);

                nbErreurs = 1;
                callback({sauvegarde: 'error'});
                return;
            }
            var idEvenement = $('#wizard').attr('id-evenement');
            var listApres = creationListAvantApres(idEvenement, dateEvenement, 'apres', idTypeEvenement);
            var listMatriculeApres = [];
            $.each(listApres, function (index, id_ue) {
                listMatriculeApres.push(id_ue.matricule);
                dateEvenementApres = id_ue.date_evenement;
            });
            map_apres.markerFeatureByAttribute(listMatriculeApres, false, false, 'mat_mat_cr_t', false);
            var listMatriculeAvant = [];
            map_apres.LotFeatureByAttribute(listMatriculeApres, true, false, 'num_lot', false, idEvenement, idTypeEvenement, listMatriculeAvant);
            refreshTableApresOperationCadastrale(true);
            refreshDatatables();
            desactiverSauvegarde();
            // var etapeOrdre = 2; // recharger l'étape 'Unité(s) d'évaluation'
            // $('#modal-step' + etapeOrdre).attr('recharger', 'oui');

            infos.ajouterMessageToast({
                message: response.msg,
                messageDuree: 500,
                icone: 'fa-check-circle-o',
                iconeCouleur: 'green'
            });
            nbErreurs = 0;
            callback({sauvegarde: 'ok'});
            $('#table-apres-operation-cadastrale').attr('modifie', 'False');


        },
        error: function (xhr, ajaxOptions, thrownError) {
            infos.ajouterMessageToast({
                message: 'Une erreur s\'est produite. Contactez un administrateur.',
                messageDuree: 0
            });
            nbErreurs = 1;
            callback({sauvegarde: 'error'});
        }
    });
}

function validerUeGeomIdentique(idMunicipalite, lotsAvant, lotsApres, dateEvenement) {
    var reponse = '';
    var params = {
        'id_municipalite': idMunicipalite,
        'lots_avant': lotsAvant,
        'lots_apres': lotsApres,
        'date_evenement': dateEvenement
    };

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/operation-ue/valider-ue-geom-identique/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            reponse = response.est_valide;
        }
    });
    return reponse;
}
